import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import Tickets from '../../components/views/admin/Tickets'

/**
 * Anforderungen — nur für die Administration.
 *
 * Die Anforderungen werden von Junior Achievement erfasst und beschreiben,
 * was an der Anwendung geändert werden soll. Für Schulen ist das nichts.
 */
function TicketsPage(props) {
	if ([TRoles.ADMIN, TRoles.FEDERAL_ADMIN].includes(props.role)) return <Tickets />

	return <Redirect to={TRoutes.DASHBOARD} />
}

TicketsPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(TicketsPage)
